<!-- 默认参数 -->
<template>
  <div class="defaultParams">

    <div class="formContainer">
      <label>缴费时间</label>
      <el-select v-model="timeType" placeholder="请选择" style="width: 150px;" :disabled='!canEdit'>
        <el-option v-for="item in timeTypes" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="deductionFeeDay" placeholder="请选择" style="width: 150px;margin-left: 20px;"
        :disabled='!canEdit'>
        <el-option v-for="item in timeList" :key="item.value" :label="item.text" :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="formContainer">
      <label>默认菜单权限</label>
      <el-select v-model="roleid" placeholder="请选择" style="width: 320px;" :disabled='!canEdit'>
        <el-option v-for="item in roleList" :key="item.roleid" :label="item.rolename" :value="item.roleid">
        </el-option>
      </el-select>
    </div>
    <div class="formContainer">
      <label>余额告警值</label>
      <input type="number" v-show="!canEdit" v-model="balanceAlarm" placeholder="请输入告警值" disabled />
      <input type="number" v-show="canEdit" v-model="balanceAlarm" placeholder="请输入告警值" />
    </div>
    <div class="formContainer">
      <label>基本电费单价</label>
      <input type="number" v-show="!canEdit" v-model="basicElectricityCharges" min="0" placeholder="请输入基本电费" disabled />
      <input type="number" v-show="canEdit" v-model="basicElectricityCharges" min="0" placeholder="请输入基本电费"
        @keydown="keydownFloat($event)" />
    </div>
    <!-- <div class="devideArea">
			<div class="devideLine"></div><span>银行代扣必填</span>
			<div class="devideLine"></div>
		</div>
		<div class="formContainer">
			<label>应用appid</label>
			<input type="text" v-show="!canEdit" v-model="icbcAppId" placeholder="请输入应用appid" disabled />
			<input type="text" v-show="canEdit" v-model="icbcAppId" placeholder="请输入应用appid" />
		</div>
		<div class="formContainer">
			<label>单位简称</label>
			<input type="text" v-show="!canEdit" v-model.trim="icbcUnitCode" placeholder="请输入单位简称" disabled />
			<input type="text" v-show="canEdit" v-model.trim="icbcUnitCode" placeholder="请输入单位简称" />
		</div>
		<div class="formContainer">
			<label>企业客户编号</label>
			<input type="text" v-show="!canEdit" v-model="icbcCorpCis" placeholder="请输入企业客户编号" disabled />
			<input type="text" v-show="canEdit" v-model="icbcCorpCis" placeholder="请输入企业客户编号" />
		</div>
		<div class="formContainer">
			<label>项目编号</label>
			<input type="text" v-show="!canEdit" v-model="icbcProjectId" placeholder="请输入项目编号" disabled />
			<input type="text" v-show="canEdit" v-model="icbcProjectId" placeholder="请输入项目编号" />
		</div>
		<div class="devideArea">
			<div class="devideLine"></div><span>微信支付必填</span>
			<div class="devideLine"></div>
		</div>
		<div class="formContainer">
			<label>子商户号</label>
			<input type="text" v-show="!canEdit" v-model="wxMchId" placeholder="请输入子商户号" disabled />
			<input type="text" v-show="canEdit" v-model="wxMchId" placeholder="请输入子商户号" />
		</div> -->
    <div :class="['btnsContainer',{'active':canEdit}]">
      <button v-show="!canEdit" @click="canEdit = true">编辑</button>
      <button v-show="canEdit" @click="canEdit = false">取消</button>
      <button v-show="canEdit" @click="save">保存</button>
    </div>

  </div>
</template>

<script>
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import userManagerStore from '@/page/userManager/userManagerStore.js'
  export default {
    components: {
      singleSelection,
    },
    props: {},
    data () {
      return {
        timeTypes: [{
          label: '按月',
          value: 'month'
        }],
        timeType: 'month',
        balanceAlarm: 200,
        basicElectricityCharges: 0,
        icbcAppId: undefined,
        icbcUnitCode: undefined,
        icbcCorpCis: undefined,
        icbcProjectId: undefined,
        deductionFeeDay: 1,
        wxMchId: undefined,
        autoCheck: 0,
        canEdit: false,
        roleid: '',
      }
    },
    created () {
      userManagerStore.commit('getAllRoles')
    },
    mounted () {
      this.getDefaultParams()
    },
    destroyed () {},
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      roleList () {
        return userManagerStore.state.allRoles
      },
      timeList () {
        switch(this.timeType) {
          case 'month':
            var list=[]
            for(let i=1;i<32;i++) {
              list.push({
                text: i+'日',
                value: i
              })
            }
            return list
            break
          case 'day':
            var list=[]
            for(let i=0;i<24;i++) {
              list.push({
                text: (i>9? i:'0'+i)+':00',
                value: i
              })
            }
            return list
            break
          default:
            return []
            break
        }
      }
    },
    watch: {},
    methods: {
      keydownFloat (ev) {
        if(ev.keyCode==109||ev.keyCode==229) {
          ev.preventDefault()
        }
      },
      // 获取单位的默认参数
      getDefaultParams () {
        this.$api.meterReadingApi.getBaseMeterDefault(this.nowUnit.id,respon => {
          if(!isempty(respon)) {
            this.autoCheck=respon.deductionFeeDay-1
            this.deductionFeeDay=respon.deductionFeeDay
            this.balanceAlarm=respon.balanceAlarm
            this.basicElectricityCharges=isempty(respon.basicElectricityCharges)? '':respon.basicElectricityCharges/100
            this.icbcAppId=respon.icbcAppId
            this.icbcCorpCis=respon.icbcCorpCis
            this.icbcProjectId=respon.icbcProjectId
            this.icbcUnitCode=respon.icbcUnitCode
            this.wxMchId=respon.wxMchId
            this.roleid=respon.roleId
          }
        },err => {
          this.$dialogMethod.showMessage(err)
        })
      },
      save () {
        if(isNaN(parseFloat(this.basicElectricityCharges))||(this.basicElectricityCharges.toString().indexOf('.')>0&&this.basicElectricityCharges.toString().split('.')[1].length>2)) {
          this.$dialogMethod.showMessage('请填写正确的金额')
          return
        }
        /*var regex = /^[a-zA-Z]{1,6}$/
        if(!regex.test(this.icbcUnitCode)) {
          this.$dialogMethod.showMessage('请填写格式正确（1-6位英文）的单位简称')
        }*/
        this.$api.meterReadingApi.saveBaseMeterDefault(this.nowUnit.id,this.deductionFeeDay,this.balanceAlarm,this.basicElectricityCharges*100,this.icbcAppId,this.icbcUnitCode,this.icbcCorpCis,this.icbcProjectId,this.wxMchId,this.roleid,respon => {
          this.canEdit=false
          this.$dialogMethod.showMessage('保存成功！')
        },err => {
          this.$dialogMethod.showMessage(err)
        })
      }
    }
  }
</script>

<style scoped>
  .defaultParams {
    height: calc(100% - 40px);
    background-color: #FFFFFF;
    padding: 20px;
    position: relative;
  }

  .formContainer {
    margin-bottom: 12px;
  }

  .formContainer>label {
    min-width: 90px;
    text-align: right;
    display: inline-block;
    margin-right: 12px;
    line-height: 32px;
  }

  .formContainer>input {
    width: 295px;
    height: 26px;
  }

  .formContainer>textarea {
    width: 295px;
    height: 60px;
    resize: none;
    vertical-align: top;
  }

  .formContainer>label>span {
    display: inline-block;
    width: 8px;
  }

  .formContainer>>>.selection-body {
    display: inline-flex;
    padding: 0;
    margin-right: 20px;
  }

  .formContainer>>>.selection>p {
    line-height: 32px;
    height: 32px;
  }

  .btnsContainer {
    position: absolute;
    width: calc(100% - 40px);
    /* bottom: 50px; */
    /* text-align: center; */
    margin-left: 3.55rem;
    /* margin-left: 285px; */
  }

  .btnsContainer.active {
    margin-left: 2.85rem;
  }

  .btnsContainer>button {
    color: #FFFFFF;
    background-color: #409EFF;
    border-radius: 4px;
    height: 36px;
    padding: 0 12px;
    margin: 0 10px;
  }

  .devideArea {
    width: 420px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .devideLine {
    width: 150px;
    border-bottom: dotted 1px #999999;
  }
</style>